import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  getDataClientAptosByEmail,
  getDataClientByEmailInDB,
  getDataCLMFClientVtexByEmail,
} from "../../api/apiNewUser";
import ShowDataAptos from "./ShowDataAptos";
import Spinner from "react-bootstrap/Spinner";
import ShowDataVtex from "./ShowDataVtex";
import ShowDataDB from "./ShowDataDB";
import { findUserByEmailInOldDB } from "../../api/apiAdmin";
import ShowDataOldDB from "./ShowDataOldDB";

const determinaFontSize = (ancho) => {
  if (ancho < 400) return "10px";
  if (ancho >= 400 && ancho < 600) return "12px";
  if (ancho >= 600 && ancho < 800) return "14px";
  if (ancho >= 800 && ancho < 1000) return "16px";
  if (ancho >= 1000) return "18px";
};

const MyModal = ({ showModal, handleModal, emailUser, tableUsers }) => {
  const [dataClientAptos, setDataClientAptos] = useState("");
  const [dataClientVtex, setDataClientVtex] = useState("");
  const [dataClientDB, setDataClientDB] = useState("");
  const [myFontSize, setMyFontSize] = useState("12px"); //determinaFontSize(window.innerWidth)
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (emailUser) {
      consultDataUser(emailUser);
    }

    return;
  }, []);

  const consultDataUser = async (email) => {
    //setIsLoading(true);
    //setIsConsult(false);
    

    setShowSpinner(true);
    const dataAptos = await getDataClientAptosByEmail(email);
    if (dataAptos) setShowSpinner(false);

    if (dataAptos.data?.resDataClient)
      setDataClientAptos(dataAptos.data.resDataClient);
    else setDataClientAptos("");
    //setIsLoading(true);

    setShowSpinner(true);
    const dataVtex = await getDataCLMFClientVtexByEmail(email);
    if (dataVtex) setShowSpinner(false);

    if (dataVtex.data?.dataCL[0]) {
      //setIsLoading(false);
      setDataClientVtex(dataVtex);
    } else setDataClientVtex("");
    //setIsLoading(true);

    setShowSpinner(true);
    let dataDB = null;
    if (tableUsers){
      dataDB = await getDataClientByEmailInDB(email);
    }else {
      dataDB = await findUserByEmailInOldDB(email);
    }
     
    if (dataDB) setShowSpinner(false);

    if (dataDB.data?.result && tableUsers) {
      //setIsLoading(false);
      setDataClientDB(dataDB);
    } 
    if(!tableUsers&& dataDB.response?.data?.result[0]){
      setDataClientDB(dataDB.response);
    }
    //console.log("dataDB:..", dataDB);
    if (
      !dataAptos.data?.resDataClient &&
      !dataDB.data?.result &&
      !dataVtex.data?.dataCL[0]
    ) {
      //setIsConsult(true);
      console.log("Consulta Completa:..");
    } else {
      //setIsConsult(false);
      console.log("Consulta NO Completa:..");
    }
    //setIsLoading(false);
  };
  return (
    <Modal show={showModal} onHide={handleModal}>
      <Modal.Header closeButton>
        <Modal.Title>Datos del Cliente <Spinner className={showSpinner?'d-block':'d-none'}/> </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {dataClientAptos && (
          <div>
            <h3 className="text-center text-danger fs-3">
              Datos de Cliente en Aptos
            </h3>
            <ShowDataAptos
              data={dataClientAptos}
              emailUser={emailUser}
              myFontSize={myFontSize}
            />
          </div>
        )}
        {(dataClientVtex.data?.dataCL[0] || dataClientVtex.data?.dataMF[0]) && (
        <div>
          <h3 className="text-center text-danger fs-3">Datos de Cliente en VTEX</h3>
          <ShowDataVtex data={dataClientVtex} myFontSize={myFontSize} />
        </div>
      )}
      {dataClientDB && tableUsers && (
        <div>
          <h3 className="text-center text-danger fs-3">Datos de Cliente en DB</h3>
          <ShowDataDB data={dataClientDB} myFontSize={myFontSize}/>
        </div>
      )}
      {dataClientDB && !tableUsers && (
        <div>
          <h3 className="text-center text-danger fs-3">Datos de Cliente en DB</h3>
          <ShowDataOldDB data={dataClientDB} myFontSize={myFontSize}/>
        </div>
      )}
      {!dataClientAptos&&!dataClientDB&&!dataClientVtex&&<h3 className="text-danger text-center">No Data Client...</h3>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MyModal;
